import React from "react";
import { User } from "../../context/UserContext";
import { ReactComponent as PencilIcon } from "../../assets/icons/svg/pen-icon.svg";

interface UserCardProps {
  user: User;
  onEdit?: (user: User) => void;
}

const UserCard: React.FC<UserCardProps> = ({ user, onEdit }) => {
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 w-full hover:shadow-sm transition-shadow relative">
      {/* Admin badge in top-left corner */}
      {user.role === "admin" && (
        <div className="absolute -top-1 -left-2 bg-[#DFEDE5] text-[#0C6630] text-[10px] 3xl:text-[12px] px-2 py-0.5 rounded-[4px] font-medium font-mono">
          Admin
        </div>
      )}
      
      <div className="flex items-center justify-between pt-2">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-xs font-medium text-blue-700">
              {getInitials(user.name)}
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="text-sm font-medium text-gray-900 truncate">{user.name}</h3>
            <p className="text-xs text-gray-500 truncate">{user.email}</p>
          </div>
        </div>
                
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={() => onEdit && onEdit(user)}
            className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
          >
             <PencilIcon className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserCard;